import axios from "axios"; 
import { useAuthStore } from "../store/authStore";
import { API_URL } from "./apiHelper";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": "tr",
  },
});

// Token yenileme işlemi
const refreshToken = async () => {
  try {
    const authStore = useAuthStore.getState();
    const body = { refreshToken: authStore.refreshToken };
    
    const response = await axios.post(`${API_URL}/v1/Auth/refresh-token`, body);
    const { token, refreshToken } = response.data.data;

    authStore.setUser(authStore.claims, token, refreshToken,authStore.userId,authStore.userName);
    localStorage.setItem("token", token);

    return token;
  } catch (error) {
    console.error("Token yenileme hatası:", error);
    const authStore = useAuthStore.getState();
    authStore.setUser(null, null,null,null);
    localStorage.removeItem("token");
    throw new Error("Oturumunuz sonlandırıldı. Lütfen tekrar giriş yapın.");
  }
};

// API istek öncesi interceptor
api.interceptors.request.use(
  (config) => {
    const { token } = useAuthStore.getState();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (process.env.NODE_ENV === "development") {
      console.log("API isteği gönderiliyor:", config.url);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// API yanıt sonrası interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshToken();
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
